export default "__VITE_ASSET__B9M4MN2v__"